function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
module.exports = function (e) {
  var r = {};
  function t(n) {
    if (r[n]) return r[n].exports;
    var u = r[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(u.exports, u, u.exports, t), u.l = !0, u.exports;
  }
  return t.m = e, t.c = r, t.d = function (e, r, n) {
    t.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: n
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, r) {
    if (1 & r && (e = t(e)), 8 & r) return e;
    if (4 & r && "object" == _typeof(e) && e && e.__esModule) return e;
    var n = Object.create(null);
    if (t.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var u in e) t.d(n, u, function (r) {
      return e[r];
    }.bind(null, u));
    return n;
  }, t.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return t.d(r, "a", r), r;
  }, t.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, t.p = "", t(t.s = 0);
}([function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  });
  var n = t(1),
    u = {
      skipInstances: [],
      refreshCall: void 0,
      requestQueueInterceptorId: void 0
    };
  r["default"] = function (e, r, t) {
    if (void 0 === t && (t = {}), "function" != typeof r) throw new Error("axios-auth-refresh requires `refreshAuthCall` to be a function that returns a promise.");
    return e.interceptors.response.use(function (e) {
      return e;
    }, function (o) {
      if (t = n.mergeOptions(n.defaultOptions, t), !n.shouldInterceptError(o, t, e, u)) return Promise.reject(o);
      u.skipInstances.push(e);
      var s = n.createRefreshCall(o, r, u);
      return n.createRequestQueueInterceptor(e, u, t), s["finally"](function () {
        return n.unsetCache(e, u);
      })["catch"](function (e) {
        return Promise.reject(e);
      }).then(function () {
        return n.resendFailedRequest(o, n.getRetryInstance(e, t));
      });
    });
  };
}, function (e, r, t) {
  "use strict";

  var n = this && this.__assign || function () {
    return (n = Object.assign || function (e) {
      for (var r, t = 1, n = arguments.length; t < n; t++) for (var u in r = arguments[t]) Object.prototype.hasOwnProperty.call(r, u) && (e[u] = r[u]);
      return e;
    }).apply(this, arguments);
  };
  Object.defineProperty(r, "__esModule", {
    value: !0
  });
  var u = t(2);
  r.defaultOptions = {
    statusCodes: [401],
    skipWhileRefreshing: !0
  }, r.mergeOptions = function (e, r) {
    return n(n({}, e), r);
  }, r.shouldInterceptError = function (e, r, t, n) {
    return !!e && (!e.config || !e.config.skipAuthRefresh) && !(!e.response || !r.statusCodes.includes(parseInt(e.response.status))) && (!r.skipWhileRefreshing || !n.skipInstances.includes(t));
  }, r.createRefreshCall = function (e, r, t) {
    return t.refreshCall || (t.refreshCall = r(e), "function" == typeof t.refreshCall.then) ? t.refreshCall : (console.warn("axios-auth-refresh requires `refreshTokenCall` to return a promise."), Promise.reject());
  }, r.createRequestQueueInterceptor = function (e, r, t) {
    return void 0 === r.requestQueueInterceptorId && (r.requestQueueInterceptorId = e.interceptors.request.use(function (e) {
      return r.refreshCall["catch"](function () {
        throw new u["default"].Cancel("Request call failed");
      }).then(function () {
        return t.onRetry ? t.onRetry(e) : e;
      });
    })), r.requestQueueInterceptorId;
  }, r.unsetCache = function (e, r) {
    e.interceptors.request.eject(r.requestQueueInterceptorId), r.requestQueueInterceptorId = void 0, r.refreshCall = void 0, r.skipInstances = r.skipInstances.filter(function (r) {
      return r !== e;
    });
  }, r.getRetryInstance = function (e, r) {
    return r.retryInstance || e;
  }, r.resendFailedRequest = function (e, r) {
    return e.config.skipAuthRefresh = !0, r(e.response.config);
  };
}, function (e, r) {
  e.exports = require("axios");
}]);